import { FileText, FileDown, Upload } from "lucide-react";
import styles from '../../docxTemplateWidget.module.css';

interface TemplateFileSectionProps {
    templateName: string;
    onDownload: () => void;
    isDownloading: boolean;
    onReplace: () => void;
    templateId?: number;
}

export default function TemplateFileSection({
    templateName,
    onDownload,
    isDownloading,
    onReplace,
    templateId
}: TemplateFileSectionProps) {
    return (
        <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Template File</h3>
            <div className={styles.templateFile}>
                <div className={styles.templateFileHeader}>
                    <FileText size={20} className={styles.fileIcon} />
                    <span className={styles.templateNameLabel}>{templateName}</span>
                </div>
                {templateId && (
                    <div className={styles.buttonContainer}>
                        <button
                            className={styles.button}
                            onClick={onDownload}
                            disabled={isDownloading}
                        >
                            <FileDown size={16} className={styles.buttonIcon} />
                            Download
                        </button>
                        <button
                            className={styles.button}
                            onClick={onReplace}
                            disabled={isDownloading}
                        >
                            <Upload size={16} className={styles.buttonIcon} />
                            Replace
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
} 